// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Patient Chart only. Namespaced so Dashboard / Patients / Appointments stay unchanged. */

.emr-chart,
.emr-chart *,
.emr-chart *::before,
.emr-chart *::after,
.emr-chart-popper,
.emr-chart-popper *,
.emr-chart-popper *::before,
.emr-chart-popper *::after,
.emr-chart-dialog,
.emr-chart-dialog *,
.emr-chart-dialog *::before,
.emr-chart-dialog *::after {
  border-radius: 0 !important;
}

.emr-chart {
  --emr-chart-primary: #1976d2;
  --emr-chart-primary-dark: #0d47a1;
  --emr-chart-text: #212121;
  --emr-chart-muted: #616161;
  --emr-chart-border: #e0e0e0;
  --emr-chart-surface: #ffffff;
  --emr-chart-bg: #f4f7f9;
  min-width: 0;
  width: 100%;
  color: var(--emr-chart-text);
}

.emr-chart a,
.emr-chart .emr-chart-link {
  color: var(--emr-chart-primary);
}

.emr-chart-header {
  background: var(--emr-chart-surface);
  border: 1px solid var(--emr-chart-border);
  padding: 12px 16px;
  margin-bottom: 12px;
}

.emr-chart-header__row {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.emr-chart-header__identity {
  display: flex;
  min-width: 0;
  flex: 1 1;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 12px 16px;
}

.emr-chart-back {
  display: inline-flex;
  align-items: center;
  gap: 2px;
  margin-bottom: 6px;
  font-size: var(--emr-type-label);
  font-weight: 600;
  color: var(--emr-chart-primary);
  text-decoration: none;
}

.emr-chart-back:hover {
  text-decoration: underline;
}

.emr-chart-avatar {
  display: flex;
  height: 44px;
  width: 44px;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  background: #e3f2fd;
  color: var(--emr-chart-primary);
  font-size: var(--emr-type-body);
  font-weight: 700;
  letter-spacing: 0.02em;
}

.emr-chart-name {
  min-width: 0;
  font-size: var(--emr-type-page-title);
  font-weight: 600;
  line-height: 1.25;
  color: var(--emr-chart-text);
}

.emr-chart-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 6px 14px;
  margin-top: 4px;
  font-size: var(--emr-type-body);
  color: var(--emr-chart-muted);
}

.emr-chart-status {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: var(--emr-type-metadata);
  font-weight: 600;
  border: 1px solid transparent;
}

.emr-chart-status.is-active {
  background: #e8f5e9;
  color: #2e7d32;
}

.emr-chart-status.is-inactive {
  background: #eceff1;
  color: #546e7a;
}

.emr-chart-actions {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
}

.emr-chart-btn {
  height: 36px !important;
  border-radius: 0 !important;
  border: 1px solid var(--emr-chart-border) !important;
  background: #fff !important;
  color: var(--emr-chart-text) !important;
  font-size: var(--emr-type-button-compact) !important;
  font-weight: 600 !important;
  box-shadow: none !important;
}

.emr-chart-btn:hover {
  background: #f5f8fb !important;
}

.emr-chart-nav {
  background: transparent;
  margin-bottom: 0;
}

.emr-chart .chart-folder,
.emr-chart .chart-folder-nav,
.emr-chart .chart-folder-body,
.emr-chart .chart-folder-sheet {
  background: transparent;
  border: 0;
  box-shadow: none;
  filter: none;
  padding: 0;
  margin: 0;
}

.emr-chart .chart-folder-body::before,
.emr-chart .chart-subtabs--domain::before,
.emr-chart .chart-subtabs--domain::after,
.emr-chart .chart-subtabs--domain.chart-subtabs--clinical::before,
.emr-chart .chart-subtabs--domain.chart-subtabs--clinical::after {
  display: none !important;
  content: none !important;
}

.emr-chart .chart-subtab::before,
.emr-chart .chart-subtab::after {
  display: none !important;
  content: none !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  background: transparent !important;
}

.emr-chart .chart-folder-nav {
  display: flex;
  flex-direction: column;
  gap: 10px;
  overflow: visible;
}

.emr-chart .chart-subtabs {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0;
  width: 100%;
  margin: 0;
  padding: 0;
  overflow: visible;
}

.emr-chart .chart-subtab {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  margin: 0;
  border-style: solid !important;
  border-width: 0 !important;
  box-shadow: none !important;
  filter: none !important;
  letter-spacing: 0;
  text-transform: none;
  white-space: nowrap;
  cursor: pointer;
}

/* Domain bar: three equal Front Desk / Clinical / Billing segments. */
.emr-chart .chart-subtabs--domain.chart-subtabs--clinical {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  justify-content: stretch;
  background: #e8eef4;
  border: 1px solid #c5d0dc;
  border-bottom: 0;
  padding: 0;
  min-height: 42px;
}

.emr-chart .chart-subtabs--domain.chart-subtabs--clinical .chart-subtab,
.emr-chart .chart-subtabs--domain .chart-subtab {
  width: 100% !important;
  max-width: none;
  flex: none;
  min-width: 0;
  min-height: 42px;
  margin: 0;
  padding: 10px 12px;
  background: transparent !important;
  color: #455a64 !important;
  font-size: var(--emr-type-body);
  font-weight: 600;
}

.emr-chart .chart-subtabs--domain .chart-subtab:hover:not(.is-active) {
  background: rgba(255, 255, 255, 0.55) !important;
  color: #1565c0 !important;
}

.emr-chart .chart-subtabs--domain.chart-subtabs--clinical .chart-subtab.is-active,
.emr-chart .chart-subtabs--domain .chart-subtab.is-active,
.emr-chart .chart-subtabs--domain .chart-subtab.is-dark.is-active {
  z-index: 3;
  width: 100% !important;
  min-height: 42px;
  padding: 10px 12px;
  background: #1976d2 !important;
  color: #ffffff !important;
  border-width: 0 !important;
  margin: 0;
}

.emr-chart .chart-subtabs--domain .chart-divider-label {
  display: block;
  font-size: var(--emr-type-body);
  font-weight: var(--emr-weight-title);
  letter-spacing: 0;
  text-transform: none;
}

.emr-chart .chart-subtabs--domain .chart-subtab-icon {
  width: 18px;
  height: 18px;
}

/*
 * Clinical subtabs: physical tab sitting on a 1px folder line.
 * Domain tabs (Front Desk / Clinical / Billing) are not styled here.
 */
.emr-chart .chart-subtabs:not(.chart-subtabs--domain) {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  position: relative;
  background-color: #dfe6ee;
  background-image: linear-gradient(to right, #64b5f6, #64b5f6);
  background-size: 100% 1px;
  background-position: 0 100%;
  background-repeat: no-repeat;
  border: 0 !important;
  box-shadow: none !important;
  padding: 0 8px;
  overflow-x: auto;
  overflow-y: visible;
  min-height: 32px;
  margin: 0 0 16px;
}

.emr-chart .chart-subtabs:not(.chart-subtabs--domain)::after {
  display: none !important;
  content: none !important;
}

.emr-chart .chart-subtabs:not(.chart-subtabs--domain).chart-subtabs--clinical .chart-subtab,
.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab {
  min-height: 29px;
  margin: 0;
  padding: 6px 12px 7px;
  background: transparent !important;
  color: #607080 !important;
  font-size: var(--emr-type-label);
  font-weight: 600;
  box-shadow: none !important;
  filter: none !important;
}

.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab:hover:not(.is-active) {
  color: #1565c0 !important;
  background: rgba(255, 255, 255, 0.55) !important;
}

.emr-chart .chart-subtabs:not(.chart-subtabs--domain).chart-subtabs--clinical .chart-subtab.is-active,
.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab.is-active,
.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab.is-dark.is-active {
  z-index: 5;
  align-self: stretch;
  min-height: 32px;
  padding: 4px 12px 7px;
  background: #ffffff !important;
  background-clip: padding-box !important;
  color: #0d47a1 !important;
  font-weight: 700;
  border-top-width: 3px !important;
  border-right-width: 1px !important;
  border-left-width: 1px !important;
  border-bottom-width: 0 !important;
  border-top-color: #1976d2 !important;
  border-right-color: #64b5f6 !important;
  border-left-color: #64b5f6 !important;
  border-bottom-color: transparent !important;
  margin: 0;
  box-shadow: none !important;
  filter: none !important;
  outline: none !important;
}

/* Hide the folder line only inside the tab. Side borders stay on the line. */
.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab.is-active::before {
  display: block !important;
  content: "" !important;
  position: absolute;
  top: auto !important;
  left: 0 !important;
  right: 0 !important;
  bottom: 0 !important;
  width: auto !important;
  height: 1px !important;
  margin: 0 !important;
  background: #ffffff !important;
  background-image: none !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  filter: none !important;
  transform: none !important;
  pointer-events: none;
  z-index: 6;
}

.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab.is-active::after {
  display: none !important;
  content: none !important;
  width: 0 !important;
  height: 0 !important;
  margin: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab-icon {
  width: 13px;
  height: 13px;
}

.emr-chart-workspace {
  min-width: 0;
}

.emr-chart-card,
.emr-chart .chart-panel,
.emr-chart .emr-chart-card {
  background: var(--emr-chart-surface);
  border: 1px solid var(--emr-chart-border);
  border-right: 3px solid var(--emr-chart-primary);
  box-shadow: none;
  padding: 14px;
  box-sizing: border-box;
  max-width: 100%;
}
.emr-chart .chart-folder-sheet > .space-y-4 > section,
.emr-chart .chart-folder-sheet > .space-y-4 > div[class*="border"] {
  border-right: 3px solid var(--emr-chart-primary);
  box-sizing: border-box;
  max-width: 100%;
}


.emr-chart-card__title {
  margin: 0;
  font-size: var(--emr-type-card-title);
  font-weight: 600;
  color: var(--emr-chart-text);
}

.emr-chart-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(0, 1fr);
}

.emr-chart-col {
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.emr-chart-ai {
  background: #faf7ff;
  border-color: #e4d8f0;
  border-right: 3px solid var(--emr-chart-primary);
}

.emr-chart-ai h2,
.emr-chart-ai h3 {
  color: #5e35b1;
}

.emr-chart-ai__note {
  margin: 6px 0 12px;
  font-size: var(--emr-type-helper);
  color: var(--emr-chart-muted);
}

.emr-chart-ai__block {
  margin-top: 10px;
}

.emr-chart-ai__block h3 {
  font-size: var(--emr-type-metadata);
  font-weight: var(--emr-weight-title);
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: #7e57c2;
}

.emr-chart-ai__btn {
  display: inline-flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
  height: 36px;
  border: 1px solid #d1c4e9;
  background: #fff;
  color: #9e9e9e;
  font-size: var(--emr-type-button-compact);
  font-weight: 600;
}

.emr-chart .emr-chart-card table,
.emr-chart .chart-panel table {
  min-width: 0;
}

.emr-chart .emr-chart-card [class*="overflow"],
.emr-chart-workspace {
  max-width: 100%;
}

.emr-chart .emr-chart-empty {
  margin: 0;
  padding: 8px 0;
  font-size: var(--emr-type-helper);
  color: var(--emr-chart-muted);
}

/*
 * Clinical list subtabs (Notes / Encounters / Appointments).
 *
 * Force a real table. Materialize + overflow/truncate on td can stack body cells.
 *
 * Same accepted clinical density as Medical History / Problem List / Allergies /
 * Past Surgical History: Arial, 16px text on a 16px line, 20px data rows, 2px
 * vertical cell padding. \`.emr-chart .emr-chart-dense …\` out-specifies the
 * Materialize rules prefixed to \`.emr-mz-dashboard\` without !important:
 *   .emr-mz-dashboard table { font-size: 14px }   (emr-dashboard.css overlay)
 *   .emr-mz-dashboard td, th { padding: 15px 5px }
 * Horizontal padding stays at the 6px Medical History gutter — these are the
 * widest clinical tables and 2px would collide adjacent columns.
 *
 * Nothing here selects the Summary cards, Results, or Table Designer.
 */
.emr-chart .emr-chart-dense {
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
  box-sizing: border-box;
}

.emr-chart .emr-chart-dense h2,
.emr-chart .emr-chart-dense h3,
.emr-chart .emr-chart-dense p,
.emr-chart .emr-chart-dense li,
.emr-chart .emr-chart-dense label,
.emr-chart .emr-chart-dense span,
.emr-chart .emr-chart-dense button,
.emr-chart .emr-chart-dense input,
.emr-chart .emr-chart-dense select {
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
}

.emr-chart .emr-chart-dense table {
  display: table !important;
  width: 100%;
  border-collapse: collapse;
  position: static;
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
}

.emr-chart .emr-chart-dense table thead {
  display: table-header-group !important;
  float: none;
  position: static;
}

.emr-chart .emr-chart-dense table tbody {
  display: table-row-group !important;
  float: none;
  position: static;
  overflow: visible;
  white-space: normal;
}

.emr-chart .emr-chart-dense table tr {
  display: table-row !important;
  height: 20px;
}

.emr-chart .emr-chart-dense table th,
.emr-chart .emr-chart-dense table td {
  display: table-cell !important;
  box-sizing: border-box;
  height: 20px;
  max-height: 20px;
  padding: 2px 6px;
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
  vertical-align: middle;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/* A 20px row only holds one 16px line, so the in-row status chips have to fit
   the 16px content box left by 2px + 2px cell padding. */
.emr-chart .emr-chart-dense__badge {
  display: inline-flex;
  align-items: center;
  height: 16px;
  max-height: 16px;
  padding: 0 4px;
  margin: 0;
  border-width: 0;
  font-size: 16px;
  line-height: 16px;
}

.emr-chart .emr-chart-table-wrap {
  display: block;
  max-width: 100%;
  overflow-x: auto;
}

.emr-chart .emr-chart-appt-table {
  min-width: 1080px;
}

.emr-chart .emr-chart-appt-table th,
.emr-chart .emr-chart-appt-table td {
  white-space: nowrap;
}

.emr-chart-dl {
  margin: 0;
}

.emr-chart-field {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 6px 0;
  border-bottom: 1px solid #f0f2f4;
}

.emr-chart-field dt {
  color: var(--emr-chart-muted);
  font-size: var(--emr-type-label);
}

.emr-chart-field dd {
  margin: 0;
  text-align: right;
  font-size: var(--emr-type-body);
  font-weight: 600;
  color: var(--emr-chart-text);
}

@media (min-width: 1024px) {
  .emr-chart-grid.emr-chart-grid--two {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (min-width: 1366px) {
  .emr-chart-grid {
    grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.2fr) minmax(0, 1fr);
  }
}

@media (max-width: 1023px) {
  .emr-chart .chart-subtabs--domain.chart-subtabs--clinical {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .emr-chart .chart-subtabs--domain .chart-subtab {
    min-height: 38px;
    padding: 8px 8px;
    font-size: var(--emr-type-label);
  }
}

@media (max-width: 767px) {
  .emr-chart-header {
    padding: 10px 12px;
  }

  .emr-chart-name {
    font-size: var(--emr-type-page-title-compact);
  }

  .emr-chart-actions {
    width: 100%;
  }

  .emr-chart-btn {
    flex: 1 1;
  }

  .emr-chart .chart-subtabs--domain .chart-subtab {
    min-height: 36px;
    padding: 6px 4px;
    font-size: var(--emr-type-metadata);
  }

  .emr-chart .chart-subtabs:not(.chart-subtabs--domain) {
    flex-wrap: nowrap;
    overflow-x: auto;
  }

  .emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab {
    min-height: 28px;
  }
}

/*
 * The Patient Summary Design View chrome moved to \`emr-application-designer.css\`
 * as \`.ad-*\` when the Application Designer took over the editor. The rules are
 * unchanged; they are shared now instead of Patient Summary's alone.
 */

/*
 * Surgical History UPPER editor only.
 *
 * Materialize is prefixed to \`.emr-mz-dashboard\` and injected after page CSS.
 * These rules out-specify the defaults that inflate the Add Surgical History
 * form. They must never match the Past Surgical History table, or Medical
 * History / Problem List / Allergies.
 *
 * Responsible Materialize / overlay rules (prefixed in the app):
 *   input:not([type]),
 *   input[type=text|search|date|…]:not(.browser-default)
 *     height: 3rem; margin: 0 0 8px 0; font-size: 16px;
 *     box-sizing: content-box; padding: 0; underline-only border
 *   .input-field { margin-top/bottom: 1rem }
 *   .input-field > label { position: absolute; transform: translateY(12px) }
 *   label { color: #9e9e9e }  (bare font-size is dropped in craco)
 *   select { display: none; height: 3rem; padding: 5px }
 *   [type=checkbox]:checked,:not(:checked)
 *     { position: absolute; opacity: 0; pointer-events: none }
 *   .emr-mz-dashboard input[type=text|search|email|password]
 *     { height: 40px }  — loses to Materialize :not(.browser-default)
 *
 * Past Surgical History \`table\` / \`th\` / \`td\` are intentionally omitted.
 */
.emr-chart .emr-shx__editor {
  gap: 8px;
  padding-top: 8px;
  padding-bottom: 8px;
}

.emr-chart .emr-shx__editor > .space-y-3 > :not([hidden]) ~ :not([hidden]) {
  margin-top: 6px;
}

.emr-chart .emr-shx__editor .grid {
  gap: 6px;
}

.emr-chart .emr-shx__editor h3 {
  margin: 0;
}

.emr-chart .emr-shx__label,
.emr-mz-dashboard .emr-chart .emr-shx__label {
  display: block;
  position: static;
  left: auto;
  top: auto;
  transform: none;
  height: auto;
  margin: 0 0 2px;
  padding: 0;
  font-size: var(--emr-type-label);
  font-weight: 600;
  line-height: 16px;
  color: var(--emr-chart-muted);
  cursor: default;
}

.emr-mz-dashboard .emr-chart .emr-shx__editor input:not([type]):not(.browser-default),
.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="text"]:not(.browser-default),
.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="search"]:not(.browser-default),
.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="date"]:not(.browser-default),
.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="email"]:not(.browser-default),
.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="password"]:not(.browser-default),
.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="tel"]:not(.browser-default),
.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="number"]:not(.browser-default),
.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="url"]:not(.browser-default),
.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="time"]:not(.browser-default),
.emr-mz-dashboard .emr-chart .emr-shx__editor select,
.emr-chart .emr-shx__editor input:not([type]),
.emr-chart .emr-shx__editor input[type="text"],
.emr-chart .emr-shx__editor input[type="search"],
.emr-chart .emr-shx__editor input[type="date"],
.emr-chart .emr-shx__editor input[type="email"],
.emr-chart .emr-shx__editor input[type="password"],
.emr-chart .emr-shx__editor input[type="tel"],
.emr-chart .emr-shx__editor input[type="number"],
.emr-chart .emr-shx__editor input[type="url"],
.emr-chart .emr-shx__editor input[type="time"],
.emr-chart .emr-shx__editor select {
  box-sizing: border-box !important;
  height: 20px !important;
  min-height: 20px !important;
  max-height: 20px !important;
  margin: 0 !important;
  padding: 0 6px !important;
  border: 1px solid var(--emr-chart-border) !important;
  background: #fff !important;
  box-shadow: none !important;
  font-family: var(--emr-font-sans);
  font-size: 16px !important;
  line-height: 16px !important;
}

.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="search"],
.emr-chart .emr-shx__editor input[type="search"] {
  padding-left: 32px !important;
}

.emr-mz-dashboard .emr-chart .emr-shx__editor select,
.emr-chart .emr-shx__editor select {
  display: block !important;
  appearance: auto !important;
  -webkit-appearance: auto !important;
}

.emr-mz-dashboard .emr-chart .emr-shx__editor textarea,
.emr-chart .emr-shx__editor textarea {
  box-sizing: border-box !important;
  height: auto !important;
  min-height: 56px !important;
  max-height: none !important;
  margin: 0 !important;
  padding: 6px !important;
  border: 1px solid var(--emr-chart-border) !important;
  background: #fff !important;
  box-shadow: none !important;
  font-family: var(--emr-font-sans);
  font-size: 16px !important;
  line-height: 16px !important;
  resize: vertical;
}

.emr-mz-dashboard .emr-chart .emr-shx__editor input[type="checkbox"],
.emr-chart .emr-shx__editor input[type="checkbox"] {
  position: static !important;
  left: auto !important;
  opacity: 1 !important;
  pointer-events: auto !important;
  visibility: visible !important;
  appearance: auto !important;
  -webkit-appearance: checkbox !important;
  width: 14px !important;
  height: 14px !important;
  min-height: 0 !important;
  max-height: none !important;
  margin: 2px 0 0 !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.emr-chart .emr-shx__quick {
  padding: 8px;
}

.emr-chart .emr-shx__quick .grid {
  gap: 4px;
}

.emr-chart .emr-shx__quick [data-testid^="patient-chart-shx-quick-chip"] {
  min-height: 20px;
  padding: 2px 6px;
  font-size: var(--emr-type-button-compact);
  line-height: 16px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.emr-chart .emr-shx__quick [data-testid="patient-chart-shx-search-all"] {
  height: 24px !important;
  min-height: 24px !important;
  margin-top: 8px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 16px !important;
}

/*
 * Past Surgical History table only.
 *
 * The locked Add Surgical History editor is not selected.
 * Medical History / Problem List / Allergies are not selected.
 *
 * Materialize (prefixed to .emr-mz-dashboard) sets:
 *   td, th { padding: 15px 5px; display: table-cell; vertical-align: middle }
 * Specificity (.emr-mz-dashboard td, .emr-mz-dashboard th) beats Tailwind
 * px-3 / py-2, so SANDBOX rows stay at the old ~46px Materialize height.
 * Also: .emr-mz-dashboard table { font-size: 14px } and tr { border-bottom }.
 *
 * Accepted clinical-table density: Arial 16px / 16px line-height,
 * box-sizing: border-box, 2px cell padding, 20px content height.
 */
.emr-mz-dashboard .emr-chart .emr-shx [data-testid="patient-chart-shx-table"],
.emr-chart .emr-shx [data-testid="patient-chart-shx-table"] {
  box-sizing: border-box;
  border-collapse: collapse;
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
}

.emr-mz-dashboard .emr-chart .emr-shx [data-testid="patient-chart-shx-table"] th,
.emr-mz-dashboard .emr-chart .emr-shx [data-testid="patient-chart-shx-table"] td,
.emr-chart .emr-shx [data-testid="patient-chart-shx-table"] th,
.emr-chart .emr-shx [data-testid="patient-chart-shx-table"] td {
  box-sizing: border-box;
  height: 20px;
  max-height: 20px;
  padding: 2px;
  font-family: var(--emr-font-sans);
  font-size: 16px;
  line-height: 16px;
  vertical-align: middle;
}

.emr-mz-dashboard .emr-chart .emr-shx [data-testid="patient-chart-shx-table"] button,
.emr-chart .emr-shx [data-testid="patient-chart-shx-table"] button {
  box-sizing: border-box;
  height: 16px;
  width: 16px;
  min-height: 16px;
  padding: 0;
  line-height: 16px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/emr-patient-chart.css"],"names":[],"mappings":"AAAA,0FAA0F;;AAE1F;;;;;;;;;;;;EAYE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;EACjC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,4BAA4B;AAC9B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,yCAAyC;EACzC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,SAAO;EACP,eAAe;EACf,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,WAAW;EACX,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,+BAA+B;EAC/B,+BAA+B;EAC/B,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,+BAA+B;EAC/B,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,oDAAoD;EACpD,2BAA2B;EAC3B,uCAAuC;EACvC,oDAAoD;EACpD,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;EAIE,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,SAAS;AACX;;AAEA;;;;;EAKE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,MAAM;EACN,WAAW;EACX,SAAS;EACT,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;AACjB;;AAEA,sEAAsE;AACtE;EACE,aAAa;EACb,gDAAgD;EAChD,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;EACf,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,SAAS;EACT,kBAAkB;EAClB,kCAAkC;EAClC,yBAAyB;EACzB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,+BAA+B;EAC/B,oCAAoC;EACpC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;;EAGE;AACF;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;EACzB,6DAA6D;EAC7D,yBAAyB;EACzB,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,2BAA2B;EAC3B,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;;EAEE,gBAAgB;EAChB,SAAS;EACT,qBAAqB;EACrB,kCAAkC;EAClC,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,2BAA2B;EAC3B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;;;EAGE,UAAU;EACV,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,uCAAuC;EACvC,yBAAyB;EACzB,gBAAgB;EAChB,gCAAgC;EAChC,kCAAkC;EAClC,iCAAiC;EACjC,iCAAiC;EACjC,oCAAoC;EACpC,sCAAsC;EACtC,qCAAqC;EACrC,2CAA2C;EAC3C,SAAS;EACT,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA,6EAA6E;AAC7E;EACE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;EACtB,oBAAoB;EACpB,8BAA8B;EAC9B,iCAAiC;EACjC,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,wBAAwB;EACxB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;;;EAGE,oCAAoC;EACpC,yCAAyC;EACzC,gDAAgD;EAChD,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;;EAEE,gDAAgD;EAChD,sBAAsB;EACtB,eAAe;AACjB;;;AAGA;EACE,SAAS;EACT,qCAAqC;EACrC,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,iCAAiC;EACjC,6BAA6B;AAC/B;;AAEA;;;;;;;;;;;;;;;EAeE;AACF;EACE,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;;;;;;;;EASE,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;EACtC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;EAEE,8BAA8B;EAC9B,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;yDACyD;AACzD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,cAAc;EACd,SAAS;EACT,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,wEAAwE;EAC1E;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gCAAgC;EAClC;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,6CAA6C;EAC/C;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,SAAO;EACT;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;EACrC;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE;;AAEF;;;;;;;;;;;;;;;;;;;;;;;EAuBE;AACF;EACE,QAAQ;EACR,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU;EACV,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;;;;;;;;;;;;;;;;;;;;;EAsBE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,yBAAyB;EACzB,oDAAoD;EACpD,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;;EAEE,iCAAiC;EACjC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,oBAAoB;EACpB,uBAAuB;EACvB,oDAAoD;EACpD,2BAA2B;EAC3B,2BAA2B;EAC3B,iCAAiC;EACjC,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,qBAAqB;EACrB,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,2BAA2B;EAC3B,uCAAuC;EACvC,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,yCAAyC;EACzC,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;EAC5B,4BAA4B;AAC9B;;AAEA;;;;;;;;;;;;;;EAcE;AACF;;EAEE,sBAAsB;EACtB,yBAAyB;EACzB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;;AAEA;;;;EAIE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;EACjC,eAAe;EACf,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB","sourcesContent":["/* Patient Chart only. Namespaced so Dashboard / Patients / Appointments stay unchanged. */\n\n.emr-chart,\n.emr-chart *,\n.emr-chart *::before,\n.emr-chart *::after,\n.emr-chart-popper,\n.emr-chart-popper *,\n.emr-chart-popper *::before,\n.emr-chart-popper *::after,\n.emr-chart-dialog,\n.emr-chart-dialog *,\n.emr-chart-dialog *::before,\n.emr-chart-dialog *::after {\n  border-radius: 0 !important;\n}\n\n.emr-chart {\n  --emr-chart-primary: #1976d2;\n  --emr-chart-primary-dark: #0d47a1;\n  --emr-chart-text: #212121;\n  --emr-chart-muted: #616161;\n  --emr-chart-border: #e0e0e0;\n  --emr-chart-surface: #ffffff;\n  --emr-chart-bg: #f4f7f9;\n  min-width: 0;\n  width: 100%;\n  color: var(--emr-chart-text);\n}\n\n.emr-chart a,\n.emr-chart .emr-chart-link {\n  color: var(--emr-chart-primary);\n}\n\n.emr-chart-header {\n  background: var(--emr-chart-surface);\n  border: 1px solid var(--emr-chart-border);\n  padding: 12px 16px;\n  margin-bottom: 12px;\n}\n\n.emr-chart-header__row {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.emr-chart-header__identity {\n  display: flex;\n  min-width: 0;\n  flex: 1;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 12px 16px;\n}\n\n.emr-chart-back {\n  display: inline-flex;\n  align-items: center;\n  gap: 2px;\n  margin-bottom: 6px;\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  color: var(--emr-chart-primary);\n  text-decoration: none;\n}\n\n.emr-chart-back:hover {\n  text-decoration: underline;\n}\n\n.emr-chart-avatar {\n  display: flex;\n  height: 44px;\n  width: 44px;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  background: #e3f2fd;\n  color: var(--emr-chart-primary);\n  font-size: var(--emr-type-body);\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.emr-chart-name {\n  min-width: 0;\n  font-size: var(--emr-type-page-title);\n  font-weight: 600;\n  line-height: 1.25;\n  color: var(--emr-chart-text);\n}\n\n.emr-chart-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px 14px;\n  margin-top: 4px;\n  font-size: var(--emr-type-body);\n  color: var(--emr-chart-muted);\n}\n\n.emr-chart-status {\n  display: inline-flex;\n  align-items: center;\n  padding: 2px 8px;\n  font-size: var(--emr-type-metadata);\n  font-weight: 600;\n  border: 1px solid transparent;\n}\n\n.emr-chart-status.is-active {\n  background: #e8f5e9;\n  color: #2e7d32;\n}\n\n.emr-chart-status.is-inactive {\n  background: #eceff1;\n  color: #546e7a;\n}\n\n.emr-chart-actions {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n}\n\n.emr-chart-btn {\n  height: 36px !important;\n  border-radius: 0 !important;\n  border: 1px solid var(--emr-chart-border) !important;\n  background: #fff !important;\n  color: var(--emr-chart-text) !important;\n  font-size: var(--emr-type-button-compact) !important;\n  font-weight: 600 !important;\n  box-shadow: none !important;\n}\n\n.emr-chart-btn:hover {\n  background: #f5f8fb !important;\n}\n\n.emr-chart-nav {\n  background: transparent;\n  margin-bottom: 0;\n}\n\n.emr-chart .chart-folder,\n.emr-chart .chart-folder-nav,\n.emr-chart .chart-folder-body,\n.emr-chart .chart-folder-sheet {\n  background: transparent;\n  border: 0;\n  box-shadow: none;\n  filter: none;\n  padding: 0;\n  margin: 0;\n}\n\n.emr-chart .chart-folder-body::before,\n.emr-chart .chart-subtabs--domain::before,\n.emr-chart .chart-subtabs--domain::after,\n.emr-chart .chart-subtabs--domain.chart-subtabs--clinical::before,\n.emr-chart .chart-subtabs--domain.chart-subtabs--clinical::after {\n  display: none !important;\n  content: none !important;\n}\n\n.emr-chart .chart-subtab::before,\n.emr-chart .chart-subtab::after {\n  display: none !important;\n  content: none !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  background: transparent !important;\n}\n\n.emr-chart .chart-folder-nav {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  overflow: visible;\n}\n\n.emr-chart .chart-subtabs {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0;\n  width: 100%;\n  margin: 0;\n  padding: 0;\n  overflow: visible;\n}\n\n.emr-chart .chart-subtab {\n  position: relative;\n  z-index: 1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  margin: 0;\n  border-style: solid !important;\n  border-width: 0 !important;\n  box-shadow: none !important;\n  filter: none !important;\n  letter-spacing: 0;\n  text-transform: none;\n  white-space: nowrap;\n  cursor: pointer;\n}\n\n/* Domain bar: three equal Front Desk / Clinical / Billing segments. */\n.emr-chart .chart-subtabs--domain.chart-subtabs--clinical {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  justify-content: stretch;\n  background: #e8eef4;\n  border: 1px solid #c5d0dc;\n  border-bottom: 0;\n  padding: 0;\n  min-height: 42px;\n}\n\n.emr-chart .chart-subtabs--domain.chart-subtabs--clinical .chart-subtab,\n.emr-chart .chart-subtabs--domain .chart-subtab {\n  width: 100% !important;\n  max-width: none;\n  flex: none;\n  min-width: 0;\n  min-height: 42px;\n  margin: 0;\n  padding: 10px 12px;\n  background: transparent !important;\n  color: #455a64 !important;\n  font-size: var(--emr-type-body);\n  font-weight: 600;\n}\n\n.emr-chart .chart-subtabs--domain .chart-subtab:hover:not(.is-active) {\n  background: rgba(255, 255, 255, 0.55) !important;\n  color: #1565c0 !important;\n}\n\n.emr-chart .chart-subtabs--domain.chart-subtabs--clinical .chart-subtab.is-active,\n.emr-chart .chart-subtabs--domain .chart-subtab.is-active,\n.emr-chart .chart-subtabs--domain .chart-subtab.is-dark.is-active {\n  z-index: 3;\n  width: 100% !important;\n  min-height: 42px;\n  padding: 10px 12px;\n  background: #1976d2 !important;\n  color: #ffffff !important;\n  border-width: 0 !important;\n  margin: 0;\n}\n\n.emr-chart .chart-subtabs--domain .chart-divider-label {\n  display: block;\n  font-size: var(--emr-type-body);\n  font-weight: var(--emr-weight-title);\n  letter-spacing: 0;\n  text-transform: none;\n}\n\n.emr-chart .chart-subtabs--domain .chart-subtab-icon {\n  width: 18px;\n  height: 18px;\n}\n\n/*\n * Clinical subtabs: physical tab sitting on a 1px folder line.\n * Domain tabs (Front Desk / Clinical / Billing) are not styled here.\n */\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain) {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-end;\n  position: relative;\n  background-color: #dfe6ee;\n  background-image: linear-gradient(to right, #64b5f6, #64b5f6);\n  background-size: 100% 1px;\n  background-position: 0 100%;\n  background-repeat: no-repeat;\n  border: 0 !important;\n  box-shadow: none !important;\n  padding: 0 8px;\n  overflow-x: auto;\n  overflow-y: visible;\n  min-height: 32px;\n  margin: 0 0 16px;\n}\n\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain)::after {\n  display: none !important;\n  content: none !important;\n}\n\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain).chart-subtabs--clinical .chart-subtab,\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab {\n  min-height: 29px;\n  margin: 0;\n  padding: 6px 12px 7px;\n  background: transparent !important;\n  color: #607080 !important;\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  box-shadow: none !important;\n  filter: none !important;\n}\n\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab:hover:not(.is-active) {\n  color: #1565c0 !important;\n  background: rgba(255, 255, 255, 0.55) !important;\n}\n\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain).chart-subtabs--clinical .chart-subtab.is-active,\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab.is-active,\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab.is-dark.is-active {\n  z-index: 5;\n  align-self: stretch;\n  min-height: 32px;\n  padding: 4px 12px 7px;\n  background: #ffffff !important;\n  background-clip: padding-box !important;\n  color: #0d47a1 !important;\n  font-weight: 700;\n  border-top-width: 3px !important;\n  border-right-width: 1px !important;\n  border-left-width: 1px !important;\n  border-bottom-width: 0 !important;\n  border-top-color: #1976d2 !important;\n  border-right-color: #64b5f6 !important;\n  border-left-color: #64b5f6 !important;\n  border-bottom-color: transparent !important;\n  margin: 0;\n  box-shadow: none !important;\n  filter: none !important;\n  outline: none !important;\n}\n\n/* Hide the folder line only inside the tab. Side borders stay on the line. */\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab.is-active::before {\n  display: block !important;\n  content: \"\" !important;\n  position: absolute;\n  top: auto !important;\n  left: 0 !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  width: auto !important;\n  height: 1px !important;\n  margin: 0 !important;\n  background: #ffffff !important;\n  background-image: none !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  filter: none !important;\n  transform: none !important;\n  pointer-events: none;\n  z-index: 6;\n}\n\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab.is-active::after {\n  display: none !important;\n  content: none !important;\n  width: 0 !important;\n  height: 0 !important;\n  margin: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab-icon {\n  width: 13px;\n  height: 13px;\n}\n\n.emr-chart-workspace {\n  min-width: 0;\n}\n\n.emr-chart-card,\n.emr-chart .chart-panel,\n.emr-chart .emr-chart-card {\n  background: var(--emr-chart-surface);\n  border: 1px solid var(--emr-chart-border);\n  border-right: 3px solid var(--emr-chart-primary);\n  box-shadow: none;\n  padding: 14px;\n  box-sizing: border-box;\n  max-width: 100%;\n}\n.emr-chart .chart-folder-sheet > .space-y-4 > section,\n.emr-chart .chart-folder-sheet > .space-y-4 > div[class*=\"border\"] {\n  border-right: 3px solid var(--emr-chart-primary);\n  box-sizing: border-box;\n  max-width: 100%;\n}\n\n\n.emr-chart-card__title {\n  margin: 0;\n  font-size: var(--emr-type-card-title);\n  font-weight: 600;\n  color: var(--emr-chart-text);\n}\n\n.emr-chart-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: minmax(0, 1fr);\n}\n\n.emr-chart-col {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n}\n\n.emr-chart-ai {\n  background: #faf7ff;\n  border-color: #e4d8f0;\n  border-right: 3px solid var(--emr-chart-primary);\n}\n\n.emr-chart-ai h2,\n.emr-chart-ai h3 {\n  color: #5e35b1;\n}\n\n.emr-chart-ai__note {\n  margin: 6px 0 12px;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-chart-muted);\n}\n\n.emr-chart-ai__block {\n  margin-top: 10px;\n}\n\n.emr-chart-ai__block h3 {\n  font-size: var(--emr-type-metadata);\n  font-weight: var(--emr-weight-title);\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  color: #7e57c2;\n}\n\n.emr-chart-ai__btn {\n  display: inline-flex;\n  width: 100%;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  margin-top: 12px;\n  height: 36px;\n  border: 1px solid #d1c4e9;\n  background: #fff;\n  color: #9e9e9e;\n  font-size: var(--emr-type-button-compact);\n  font-weight: 600;\n}\n\n.emr-chart .emr-chart-card table,\n.emr-chart .chart-panel table {\n  min-width: 0;\n}\n\n.emr-chart .emr-chart-card [class*=\"overflow\"],\n.emr-chart-workspace {\n  max-width: 100%;\n}\n\n.emr-chart .emr-chart-empty {\n  margin: 0;\n  padding: 8px 0;\n  font-size: var(--emr-type-helper);\n  color: var(--emr-chart-muted);\n}\n\n/*\n * Clinical list subtabs (Notes / Encounters / Appointments).\n *\n * Force a real table. Materialize + overflow/truncate on td can stack body cells.\n *\n * Same accepted clinical density as Medical History / Problem List / Allergies /\n * Past Surgical History: Arial, 16px text on a 16px line, 20px data rows, 2px\n * vertical cell padding. `.emr-chart .emr-chart-dense …` out-specifies the\n * Materialize rules prefixed to `.emr-mz-dashboard` without !important:\n *   .emr-mz-dashboard table { font-size: 14px }   (emr-dashboard.css overlay)\n *   .emr-mz-dashboard td, th { padding: 15px 5px }\n * Horizontal padding stays at the 6px Medical History gutter — these are the\n * widest clinical tables and 2px would collide adjacent columns.\n *\n * Nothing here selects the Summary cards, Results, or Table Designer.\n */\n.emr-chart .emr-chart-dense {\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n  box-sizing: border-box;\n}\n\n.emr-chart .emr-chart-dense h2,\n.emr-chart .emr-chart-dense h3,\n.emr-chart .emr-chart-dense p,\n.emr-chart .emr-chart-dense li,\n.emr-chart .emr-chart-dense label,\n.emr-chart .emr-chart-dense span,\n.emr-chart .emr-chart-dense button,\n.emr-chart .emr-chart-dense input,\n.emr-chart .emr-chart-dense select {\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-chart .emr-chart-dense table {\n  display: table !important;\n  width: 100%;\n  border-collapse: collapse;\n  position: static;\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-chart .emr-chart-dense table thead {\n  display: table-header-group !important;\n  float: none;\n  position: static;\n}\n\n.emr-chart .emr-chart-dense table tbody {\n  display: table-row-group !important;\n  float: none;\n  position: static;\n  overflow: visible;\n  white-space: normal;\n}\n\n.emr-chart .emr-chart-dense table tr {\n  display: table-row !important;\n  height: 20px;\n}\n\n.emr-chart .emr-chart-dense table th,\n.emr-chart .emr-chart-dense table td {\n  display: table-cell !important;\n  box-sizing: border-box;\n  height: 20px;\n  max-height: 20px;\n  padding: 2px 6px;\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n  vertical-align: middle;\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n/* A 20px row only holds one 16px line, so the in-row status chips have to fit\n   the 16px content box left by 2px + 2px cell padding. */\n.emr-chart .emr-chart-dense__badge {\n  display: inline-flex;\n  align-items: center;\n  height: 16px;\n  max-height: 16px;\n  padding: 0 4px;\n  margin: 0;\n  border-width: 0;\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-chart .emr-chart-table-wrap {\n  display: block;\n  max-width: 100%;\n  overflow-x: auto;\n}\n\n.emr-chart .emr-chart-appt-table {\n  min-width: 1080px;\n}\n\n.emr-chart .emr-chart-appt-table th,\n.emr-chart .emr-chart-appt-table td {\n  white-space: nowrap;\n}\n\n.emr-chart-dl {\n  margin: 0;\n}\n\n.emr-chart-field {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 6px 0;\n  border-bottom: 1px solid #f0f2f4;\n}\n\n.emr-chart-field dt {\n  color: var(--emr-chart-muted);\n  font-size: var(--emr-type-label);\n}\n\n.emr-chart-field dd {\n  margin: 0;\n  text-align: right;\n  font-size: var(--emr-type-body);\n  font-weight: 600;\n  color: var(--emr-chart-text);\n}\n\n@media (min-width: 1024px) {\n  .emr-chart-grid.emr-chart-grid--two {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (min-width: 1366px) {\n  .emr-chart-grid {\n    grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.2fr) minmax(0, 1fr);\n  }\n}\n\n@media (max-width: 1023px) {\n  .emr-chart .chart-subtabs--domain.chart-subtabs--clinical {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .emr-chart .chart-subtabs--domain .chart-subtab {\n    min-height: 38px;\n    padding: 8px 8px;\n    font-size: var(--emr-type-label);\n  }\n}\n\n@media (max-width: 767px) {\n  .emr-chart-header {\n    padding: 10px 12px;\n  }\n\n  .emr-chart-name {\n    font-size: var(--emr-type-page-title-compact);\n  }\n\n  .emr-chart-actions {\n    width: 100%;\n  }\n\n  .emr-chart-btn {\n    flex: 1;\n  }\n\n  .emr-chart .chart-subtabs--domain .chart-subtab {\n    min-height: 36px;\n    padding: 6px 4px;\n    font-size: var(--emr-type-metadata);\n  }\n\n  .emr-chart .chart-subtabs:not(.chart-subtabs--domain) {\n    flex-wrap: nowrap;\n    overflow-x: auto;\n  }\n\n  .emr-chart .chart-subtabs:not(.chart-subtabs--domain) .chart-subtab {\n    min-height: 28px;\n  }\n}\n\n/*\n * The Patient Summary Design View chrome moved to `emr-application-designer.css`\n * as `.ad-*` when the Application Designer took over the editor. The rules are\n * unchanged; they are shared now instead of Patient Summary's alone.\n */\n\n/*\n * Surgical History UPPER editor only.\n *\n * Materialize is prefixed to `.emr-mz-dashboard` and injected after page CSS.\n * These rules out-specify the defaults that inflate the Add Surgical History\n * form. They must never match the Past Surgical History table, or Medical\n * History / Problem List / Allergies.\n *\n * Responsible Materialize / overlay rules (prefixed in the app):\n *   input:not([type]),\n *   input[type=text|search|date|…]:not(.browser-default)\n *     height: 3rem; margin: 0 0 8px 0; font-size: 16px;\n *     box-sizing: content-box; padding: 0; underline-only border\n *   .input-field { margin-top/bottom: 1rem }\n *   .input-field > label { position: absolute; transform: translateY(12px) }\n *   label { color: #9e9e9e }  (bare font-size is dropped in craco)\n *   select { display: none; height: 3rem; padding: 5px }\n *   [type=checkbox]:checked,:not(:checked)\n *     { position: absolute; opacity: 0; pointer-events: none }\n *   .emr-mz-dashboard input[type=text|search|email|password]\n *     { height: 40px }  — loses to Materialize :not(.browser-default)\n *\n * Past Surgical History `table` / `th` / `td` are intentionally omitted.\n */\n.emr-chart .emr-shx__editor {\n  gap: 8px;\n  padding-top: 8px;\n  padding-bottom: 8px;\n}\n\n.emr-chart .emr-shx__editor > .space-y-3 > :not([hidden]) ~ :not([hidden]) {\n  margin-top: 6px;\n}\n\n.emr-chart .emr-shx__editor .grid {\n  gap: 6px;\n}\n\n.emr-chart .emr-shx__editor h3 {\n  margin: 0;\n}\n\n.emr-chart .emr-shx__label,\n.emr-mz-dashboard .emr-chart .emr-shx__label {\n  display: block;\n  position: static;\n  left: auto;\n  top: auto;\n  transform: none;\n  height: auto;\n  margin: 0 0 2px;\n  padding: 0;\n  font-size: var(--emr-type-label);\n  font-weight: 600;\n  line-height: 16px;\n  color: var(--emr-chart-muted);\n  cursor: default;\n}\n\n.emr-mz-dashboard .emr-chart .emr-shx__editor input:not([type]):not(.browser-default),\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"text\"]:not(.browser-default),\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"search\"]:not(.browser-default),\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"date\"]:not(.browser-default),\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"email\"]:not(.browser-default),\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"password\"]:not(.browser-default),\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"tel\"]:not(.browser-default),\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"number\"]:not(.browser-default),\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"url\"]:not(.browser-default),\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"time\"]:not(.browser-default),\n.emr-mz-dashboard .emr-chart .emr-shx__editor select,\n.emr-chart .emr-shx__editor input:not([type]),\n.emr-chart .emr-shx__editor input[type=\"text\"],\n.emr-chart .emr-shx__editor input[type=\"search\"],\n.emr-chart .emr-shx__editor input[type=\"date\"],\n.emr-chart .emr-shx__editor input[type=\"email\"],\n.emr-chart .emr-shx__editor input[type=\"password\"],\n.emr-chart .emr-shx__editor input[type=\"tel\"],\n.emr-chart .emr-shx__editor input[type=\"number\"],\n.emr-chart .emr-shx__editor input[type=\"url\"],\n.emr-chart .emr-shx__editor input[type=\"time\"],\n.emr-chart .emr-shx__editor select {\n  box-sizing: border-box !important;\n  height: 20px !important;\n  min-height: 20px !important;\n  max-height: 20px !important;\n  margin: 0 !important;\n  padding: 0 6px !important;\n  border: 1px solid var(--emr-chart-border) !important;\n  background: #fff !important;\n  box-shadow: none !important;\n  font-family: var(--emr-font-sans);\n  font-size: 16px !important;\n  line-height: 16px !important;\n}\n\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"search\"],\n.emr-chart .emr-shx__editor input[type=\"search\"] {\n  padding-left: 32px !important;\n}\n\n.emr-mz-dashboard .emr-chart .emr-shx__editor select,\n.emr-chart .emr-shx__editor select {\n  display: block !important;\n  appearance: auto !important;\n  -webkit-appearance: auto !important;\n}\n\n.emr-mz-dashboard .emr-chart .emr-shx__editor textarea,\n.emr-chart .emr-shx__editor textarea {\n  box-sizing: border-box !important;\n  height: auto !important;\n  min-height: 56px !important;\n  max-height: none !important;\n  margin: 0 !important;\n  padding: 6px !important;\n  border: 1px solid var(--emr-chart-border) !important;\n  background: #fff !important;\n  box-shadow: none !important;\n  font-family: var(--emr-font-sans);\n  font-size: 16px !important;\n  line-height: 16px !important;\n  resize: vertical;\n}\n\n.emr-mz-dashboard .emr-chart .emr-shx__editor input[type=\"checkbox\"],\n.emr-chart .emr-shx__editor input[type=\"checkbox\"] {\n  position: static !important;\n  left: auto !important;\n  opacity: 1 !important;\n  pointer-events: auto !important;\n  visibility: visible !important;\n  appearance: auto !important;\n  -webkit-appearance: checkbox !important;\n  width: 14px !important;\n  height: 14px !important;\n  min-height: 0 !important;\n  max-height: none !important;\n  margin: 2px 0 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.emr-chart .emr-shx__quick {\n  padding: 8px;\n}\n\n.emr-chart .emr-shx__quick .grid {\n  gap: 4px;\n}\n\n.emr-chart .emr-shx__quick [data-testid^=\"patient-chart-shx-quick-chip\"] {\n  min-height: 20px;\n  padding: 2px 6px;\n  font-size: var(--emr-type-button-compact);\n  line-height: 16px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.emr-chart .emr-shx__quick [data-testid=\"patient-chart-shx-search-all\"] {\n  height: 24px !important;\n  min-height: 24px !important;\n  margin-top: 8px !important;\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n  line-height: 16px !important;\n}\n\n/*\n * Past Surgical History table only.\n *\n * The locked Add Surgical History editor is not selected.\n * Medical History / Problem List / Allergies are not selected.\n *\n * Materialize (prefixed to .emr-mz-dashboard) sets:\n *   td, th { padding: 15px 5px; display: table-cell; vertical-align: middle }\n * Specificity (.emr-mz-dashboard td, .emr-mz-dashboard th) beats Tailwind\n * px-3 / py-2, so SANDBOX rows stay at the old ~46px Materialize height.\n * Also: .emr-mz-dashboard table { font-size: 14px } and tr { border-bottom }.\n *\n * Accepted clinical-table density: Arial 16px / 16px line-height,\n * box-sizing: border-box, 2px cell padding, 20px content height.\n */\n.emr-mz-dashboard .emr-chart .emr-shx [data-testid=\"patient-chart-shx-table\"],\n.emr-chart .emr-shx [data-testid=\"patient-chart-shx-table\"] {\n  box-sizing: border-box;\n  border-collapse: collapse;\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n}\n\n.emr-mz-dashboard .emr-chart .emr-shx [data-testid=\"patient-chart-shx-table\"] th,\n.emr-mz-dashboard .emr-chart .emr-shx [data-testid=\"patient-chart-shx-table\"] td,\n.emr-chart .emr-shx [data-testid=\"patient-chart-shx-table\"] th,\n.emr-chart .emr-shx [data-testid=\"patient-chart-shx-table\"] td {\n  box-sizing: border-box;\n  height: 20px;\n  max-height: 20px;\n  padding: 2px;\n  font-family: var(--emr-font-sans);\n  font-size: 16px;\n  line-height: 16px;\n  vertical-align: middle;\n}\n\n.emr-mz-dashboard .emr-chart .emr-shx [data-testid=\"patient-chart-shx-table\"] button,\n.emr-chart .emr-shx [data-testid=\"patient-chart-shx-table\"] button {\n  box-sizing: border-box;\n  height: 16px;\n  width: 16px;\n  min-height: 16px;\n  padding: 0;\n  line-height: 16px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
